import script from "./HelpPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpPassword.vue?vue&type=script&setup=true&lang=ts"

import "./HelpPassword.vue?vue&type=style&index=0&id=645642ce&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-645642ce"]])

export default __exports__